import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6ce5c7ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6ce5c7ce&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce5c7ce",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ce5c7ce')) {
      api.createRecord('6ce5c7ce', component.options)
    } else {
      api.reload('6ce5c7ce', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6ce5c7ce&scoped=true", function () {
      api.rerender('6ce5c7ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/goodList/index.vue"
export default component.exports